import history from '../../../../../../../../common/history';

const optionsDefault = {
  title: 'Предупреждение',
  centered: true,
  className: 'employee-success-form',
};

export const failureOfferVehicles = () => ({
  ...optionsDefault,
  content: `На данный момент у вас нет закрепленных ТС!`,
  okText: 'Добавить ТС',
  onOk() {
    history.push('/vehicle_card/add');
  },
});

export const failureOfferDriversAndTS = () => ({
  ...optionsDefault,
  content: `На данный момент у вас нет закрепленных ТС и водителей!`,
  okText: 'ОК',
  onOk() {
    history.push('/executorship/request');
  },
});

export const failureOfferDrivers = () => ({
  ...optionsDefault,
  content: `На данный момент у вас нет закрепленных водителей!`,
  okText: 'ОК',
  onOk() {
    history.push('/employees');
  },
});
